namespace Matrix.Data {
    export class InstanceColumns {
        static columnsKey = 'Data.Instance';
    }
}
